import { render, staticRenderFns } from "./exhibitionList.vue?vue&type=template&id=1db5289e&"
import script from "./exhibitionList.vue?vue&type=script&lang=js&"
export * from "./exhibitionList.vue?vue&type=script&lang=js&"
import style0 from "./exhibitionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports